const hasAssigneeFilterValue = (value) =>
  value !== undefined && value !== null && value !== '';

const normalizeAssigneeId = (value) =>
  hasAssigneeFilterValue(value) ? String(value) : null;

const assigneeIdsMatch = (left, right) => {
  const normalizedLeft = normalizeAssigneeId(left);
  const normalizedRight = normalizeAssigneeId(right);
  return (
    normalizedLeft !== null &&
    normalizedRight !== null &&
    normalizedLeft === normalizedRight
  );
};

const findAgentById = (agents, agentId) => {
  if (!hasAssigneeFilterValue(agentId)) {
    return null;
  }

  const agentList = Array.isArray(agents) ? agents : [];
  return (
    agentList.find((agent) => agent && assigneeIdsMatch(agent.id, agentId)) ||
    null
  );
};

export {
  assigneeIdsMatch,
  findAgentById,
  hasAssigneeFilterValue,
  normalizeAssigneeId,
};
